import { ProductDto } from '../routes/products/store/Product';
import ApiHttpClient from './ApiHttpClient';

export default class Products {
  constructor(private readonly client: ApiHttpClient) {}

  async archiveProduct(productId: string) {
    return this.client.post(`v1/provider/products/${productId}/archive`);
  }

  async createProduct(product: ProductDto): Promise<ProductDto> {
    return this.client.post('v1/provider/products', product);
  }

  async duplicateProduct(productId: string): Promise<ProductDto> {
    return this.client.post(`v1/provider/products/${productId}/duplicate`);
  }

  async getAllProducts(): Promise<ProductDto[]> {
    return this.client.get('v1/provider/products');
  }

  async getProduct(productId: string): Promise<ProductDto> {
    return this.client.get(`v1/provider/products/${productId}`);
  }

  async makeShareableLinks(
    productId: string,
    expirationDate: string,
    enableCdn?: boolean,
  ): Promise<string[]> {
    const files = await this.client.post<any, { url: string }[]>(
      `v1/provider/products/${productId}/generateShareableUrls`,
      { enableCdn, expirationDate },
    );

    return files.map(({ url }) => url);
  }

  async updateProduct(product: ProductDto) {
    return this.client.put(`v1/provider/products/${product.id}`, product);
  }
}
